import React from "react"
import MoneyFortune from "@/containers/MoneyFortune"
import {
  QuestionsData,
  resultRoleJudge,
  getTraitId
} from "@/containers/MoneyFortune/money-fortune2-data/QuestionsData"
import {
  ResultDate,
  GetAndShare
} from "@/containers/MoneyFortune/money-fortune2-data/ResultData"

export default function Index() {
  return (
    <MoneyFortune
      QuestionsData={QuestionsData}
      ResultDate={ResultDate}
      API={GetAndShare.API}
      GetAndShare={GetAndShare}
      resultRoleJudge={resultRoleJudge}
      getTraitId={getTraitId}
      // test
      customFor="WEB3Plus"
    />
  )
}
